import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type RequestEmailOtpAuthRequest = {
    email: string,
    locale: string
    current_entry_point: string
}

type RequestEmailOtpAuthSuccessResponse = {
    status: number
};

type RequestEmailOtpAuthErrorResponse = {
    message?: string,
    error: {
        message?: string
    }
};

export type RequestEmailOtpResponse = RequestEmailOtpAuthSuccessResponse | RequestEmailOtpAuthErrorResponse;

export function requestEmailOtpAuth(data: RequestEmailOtpAuthRequest): Promise<RequestEmailOtpResponse> {
    const hubApi = getHubApi();
    return hubApi.requestEmailOtpAuth(window.app.deviceIdentifier, data) as Promise<RequestEmailOtpResponse>;
}
